import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query areasActive {
        areasActive {
            id
            is_active
            name
            description
            centro
            status_text
            subAreas {
                id
                name
                description
            }
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query areasWithPagination ($page: Int, $perPage: Int) {
        areasWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                description
                centro
                is_active
                status_text
            }
        }
    }
`

/**
 * Mutations
 */
const CREATE = gql`
    mutation createArea ($input: CreateAreaInput!) {
        createArea (input: $input) {
            id
            name
            description
            centro
            is_active
            status_text
        }
    }
`

const UPDATE = gql`
    mutation updateArea ($id: ID!, $input: UpdateAreaInput!) {
        updateArea (id: $id, input: $input) {
            id
            name
            description
            centro
            is_active
            status_text
        }
    }
`

const CHANGE_STATUS = gql`
    mutation updateArea ($id: ID!, $input: UpdateAreaInput!) {
        updateArea (id: $id, input: $input) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

const DELETE = gql`
    mutation deleteArea ($id: ID!) {
        deleteArea (id: $id) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
